import { render } from "./StaffPage.vue?vue&type=template&id=53f3c7fe"
import script from "./StaffPage.vue?vue&type=script&lang=js"
export * from "./StaffPage.vue?vue&type=script&lang=js"

import "./StaffPage.vue?vue&type=style&index=0&id=53f3c7fe&lang=css"
script.render = render

export default script